{
	"description": "Entitlement template for product a6f908c8-709c-45f4-9e2d-eca25b93b94a",
	"features": []
}
